import React from 'react';
import {
  QuoteShowModal,
  QuoteStep,
  RequestUpdateAppointmentTime,
  RequestUpdateAppointmentContact,
  RequestUpdateEstimateResponse,
  ResponseAppointment,
} from 'src/types';

export interface IQuoteReasonSelection {
  [key: string]: string[] | undefined;
}

export interface IQuoteReason {
  selection: IQuoteReasonSelection;
  otherReason: string;
  note: string;
}

export interface IQuoteCar {
  search: {
    vin: string;
    plate_number: string;
    state: string;
  };
  attributes: {
    year: string;
    make: string;
    model: string;
    engine_size: string;
    mileage: string;
    vin: string;
    last_oil_change: string;
    id?: number;
  };
}

export interface IQuoteContact {
  name: string;
  email: string;
  phone: string;
  referral_code?: string;
  error?: string;
  heard_about_us?: string;
  when_like_service?: string;
  work_commute?: string;
  referral_name?: string;
}

export interface IQuoteContext {
  step: QuoteStep;
  handleSetStep: (newStep: QuoteStep) => void;

  showModal: QuoteShowModal;
  handleShowModal: (newStep: QuoteShowModal) => void;

  staticServices: string[];
  handleSetStaticServices: (services: string[]) => void;

  services: string[];
  handleSetServices: (services: string[]) => void;

  serviceDeskTab: number;
  setServiceDeskTab: (newVal: number) => void;

  reason: IQuoteReason;
  handleSetReason: (newReason: IQuoteReason) => void;

  car: IQuoteCar;
  handleSetCar: (newCar: IQuoteCar) => void;

  contact: IQuoteContact;
  handleSetContact: (newContact: IQuoteContact) => void;

  handleCreateAppointment: (data: RequestUpdateAppointmentContact) => void;
  handleUpdateAppointmentTime: (data: RequestUpdateAppointmentTime) => void;
  handleUpdateContactInfo: (data: RequestUpdateAppointmentContact) => void;
  handleRespondAppointmentEstimate: (
    data: RequestUpdateEstimateResponse
  ) => void;

  clearAll: () => void;

  login: (data: ResponseAppointment) => void;
  loggingIn: boolean;
  handleSetLoggingIn: (state: boolean) => void;
  isMechanicEstimate: boolean;
  isOfficeEstimate: boolean;
  isInstantQuote: boolean;

  requestInProgress: boolean;

  isLoggedIn: boolean;
  setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;

  paymentIntentId: string | undefined;
  setPaymentIntentId: (state: string) => void;
}

export const QuoteContext = React.createContext<IQuoteContext>({
  step: QuoteStep.QUOTE_SERVICE_DESK,
  handleSetStep: () => {},

  showModal: QuoteShowModal.NONE,
  handleShowModal: () => {},

  staticServices: [],
  handleSetStaticServices: () => {},

  services: [],
  handleSetServices: () => {},

  serviceDeskTab: 0,
  setServiceDeskTab: () => {},

  reason: {
    selection: {},
    otherReason: '',
    note: '',
  },
  handleSetReason: () => {},

  car: {
    search: {
      vin: '',
      plate_number: '',
      state: '',
    },
    attributes: {
      year: '',
      make: '',
      model: '',
      engine_size: '',
      mileage: '',
      vin: '',
      last_oil_change: '',
    },
  },
  handleSetCar: () => {},

  contact: {
    name: '',
    email: '',
    phone: '',
  },
  handleSetContact: () => {},

  handleCreateAppointment: () => {},
  handleUpdateAppointmentTime: () => {},
  handleUpdateContactInfo: () => {},
  handleRespondAppointmentEstimate: () => {},

  clearAll: () => {},

  login: () => {},
  loggingIn: false,
  handleSetLoggingIn: () => {},

  isMechanicEstimate: false,
  isOfficeEstimate: false,
  isInstantQuote: false,

  requestInProgress: false,

  isLoggedIn: false,
  setIsLoggedIn: () => {},

  paymentIntentId: undefined,
  setPaymentIntentId: () => {},
});
